/**
 * How much label a week-view block can carry (2026-09 — blocks used to be plain colour,
 * so you had to tap each one to learn what it was). Pure height math so it can be tested
 * without a layout engine: the grid is a fixed pixel height, so a block's share of it is
 * its height in pixels.
 */

/** Pixel height of the week grid's timed area (`h-[420px]` in WeekView). */
export const WEEK_GRID_PX = 420;

/** Title line box at the normal label size (10px text). */
const TITLE_LINE_PX = 12;
/** Start-time line box (9px mono). */
const TIME_LINE_PX = 11;
/** Top + bottom padding inside a labelled block. */
const PADDING_PX = 4;
/** Below this, only a single small title line fits (a 30–45 minute event). */
const TINY_BELOW_PX = 18;
/** At or above this, the start time gets its own line under the title. */
const TIME_FROM_PX = 30;

export interface BlockLabel {
  /** Tiny blocks: one line of 9px title, no padding, no time. */
  tiny: boolean;
  showTime: boolean;
  /** Lines the title may wrap to before it ellipsizes (line-clamp). */
  titleLines: number;
}

export function blockLabel(heightPx: number): BlockLabel {
  if (heightPx < TINY_BELOW_PX) return { tiny: true, showTime: false, titleLines: 1 };
  const showTime = heightPx >= TIME_FROM_PX;
  const room = heightPx - PADDING_PX - (showTime ? TIME_LINE_PX : 0);
  return { tiny: false, showTime, titleLines: Math.max(1, Math.floor(room / TITLE_LINE_PX)) };
}

/** `9a` / `9:30a` — the start time as it fits in a ~45px phone column. */
export function shortTime(iso: string): string {
  const date = new Date(iso);
  const hours = date.getHours();
  const minutes = date.getMinutes();
  const hour12 = hours % 12 === 0 ? 12 : hours % 12;
  const suffix = hours < 12 ? 'a' : 'p';
  return minutes === 0
    ? `${hour12}${suffix}`
    : `${hour12}:${`${minutes}`.padStart(2, '0')}${suffix}`;
}
